<template>
  <div class="widget-form-container">
    <div v-if="data.list.length == 0" class="form-empty">从左侧拖拽来添加组件</div>
    <el-form :size="data.config.size" label-suffix=":" :label-position="data.config.labelPosition" :label-width="data.config.labelWidth + 'px'">
      
      <draggable class="" 
        v-model="data.list" 
        v-bind="{group:'people', ghostClass: 'ghost',animation: 3000, handle: '.drag-widget'}"
        @end="handleMoveEnd"
        @add="handleWidgetAdd"
      >

        <transition-group name="fade" tag="div" class="widget-form-list">
          <template v-for="(element, index) in data.list" >
            <template v-if="element.type == 'grid'">
                <el-row class="widget-col widget-view" v-if="element && element.key" :key="element.key" 
                  type="flex"
                  :class="{active: selectWidget.key == element.key}"
                  :gutter="element.options.filter(x => x.attrName == 'gutter')[0].value ? element.options.filter(x => x.attrName == 'gutter')[0].value/1 : 0"
                  :justify="element.options.filter(x => x.attrName == 'justify')[0].value"
                  :align="element.options.filter(x => x.attrName == 'align')[0].value"
                  @click.native="handleSelectWidget(index)">
                  
                  <el-col  :key="colIndex+'1'" v-for="(col, colIndex) in element.options.filter(x => x.attrName == 'grid')[0].group" :span="col.span ? col.span : 0">
                  
                      <draggable
                        v-model="col.list"
                        :no-transition-on-drag="true"
                        v-bind="{group:'people', ghostClass: 'ghost',animation: 200, handle: '.drag-widget'}"
                        @end="handleMoveEnd"
                        @add="handleWidgetColAdd($event, element, colIndex)"
                      >
                        <transition-group name="fade" tag="div" class="widget-col-list" >
                        	<div v-for="(el, i) in col.list" :key="el.key"> 		
														
														<dynamic-item
															:key="el.key"
															v-if="el.key && el.type == 'business'"
															:element="el"
															:index="i"
															:data="col"
															:select.sync="selectWidget"
                              :isAdd="isAdd">
                              <template :slot="key" v-for="(val,key) in $slots">
                                <slot :name="key"></slot>
                              </template>
                            </dynamic-item>
														
														<widget-form-item
	                            :key="el.key"
	                            v-else-if="el.key"
	                            :element="el" 
	                            :select.sync="selectWidget" 
	                            :index="i" 
	                            :data="col">
	                          </widget-form-item>
                        	</div>
                        </transition-group>
                        
                      </draggable>
                  </el-col>
                  <div class="widget-view-action widget-col-action" v-if="selectWidget.key == element.key">
                    <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
                  </div>

                  <div class="widget-view-drag widget-col-drag" v-if="selectWidget.key == element.key">
                    <i class="el-icon-rank drag-widget"></i>
                  </div>
                </el-row>
            </template>
            <template v-else-if="element.type == 'tabs'">
						  <div class="widget-view" :class="{active: selectWidget.key == element.key}" v-if="element && element.key" :key="element.key">
						  	<el-tabs v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value" @click.native="handleSelectWidget(index)" :type="element.options.filter(x => x.attrName == 'types')[0].value" :tab-position="element.options.filter(x => x.attrName == 'tabPosition')[0].value">
							    <el-tab-pane :key="colIndex" v-for="(item,colIndex) in element.options.filter(x => x.attrName == 'tabChange')[0].group" :label="item.label" :name="item.name">
							    	<draggable
	                      v-model="item.list"
	                      :no-transition-on-drag="true"
	                      v-bind="{group:'people', ghostClass: 'ghost',animation: 200, handle: '.drag-widget'}"
	                      @end="handleMoveEnd"
	                      @add="handleWidgetColAddtab($event, element, colIndex)"
	                    >
	                      <transition-group name="fade" tag="div" class="widget-col-list">
	                      	<div v-for="(el, i) in item.list" :key="el.key">	       
	                      		<dynamic-item
															:key="el.key"
															v-if="el.key && el.type == 'business'"
															:element="el"
															:index="i"
															:data="item"
															:select.sync="selectWidget">
                              <template :slot="key" v-for="(val,key) in $slots">
                                <slot :name="key"></slot>
                              </template>
                            </dynamic-item>
														
														<widget-form-item 
	                      		  :key="el.key"
	                      		  v-else
	                      		  :element="el" 
	                      		  :select.sync="selectWidget" 
	                      		  :index="i" 
	                      		  :data="item">
	                      		</widget-form-item>
	                      	</div>
	                      </transition-group>
	                      
	                    </draggable>
							    </el-tab-pane>
							  </el-tabs>
							  <div class="widget-view-action" v-if="selectWidget.key == element.key">
				          <i class="el-icon-copy-document" @click.stop="handleWidgetClone(index)"></i>
				          <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
				        </div>
				
				        <div class="widget-view-drag" v-if="selectWidget.key == element.key">
				          <i class="el-icon-rank drag-widget"></i>
				        </div>
						  </div>
						</template>
						
						<template v-else-if="element.type == 'business'">
							<dynamic-item
								:key="element.key"
								v-if="element && element.key"
								:element="element"
								:index="index"
								:data="data"
								:select.sync="selectWidget"
                :isAdd="isAdd"
								>
                <template :slot="key" v-for="(val,key) in $slots">
                  <slot :name="key"></slot>
                </template>
              </dynamic-item>
						</template>
						
            <template v-else>
              <widget-form-item v-if="element && element.key"
                                :key="element.key"
                                :element="element"
                                :select.sync="selectWidget"
                                :index="index"
                                :data="data">
              </widget-form-item>
            </template>
          </template>
        </transition-group>
      </draggable>
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import WidgetFormItem from './WidgetFormItem'
import DynamicItem from './dynamicItem'

export default {
  components: {
    Draggable,
    WidgetFormItem,
    DynamicItem
  },
  props: ['data', 'select','allComponents'],
  data () {
    return {
      selectWidget: this.select,
      col:{
      	colIndexNum:0,
      	newIndexNum:0
      },
      tab:{
      	colIndexNum:0,
      	newIndexNum:0
      },
      isAdd:false
    }
  },
  mounted () {
    document.body.ondrop = function (event) {
      let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      if (isFirefox) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  },
  methods: {
    handleMoveEnd ({newIndex, oldIndex}) {
      
    },
    handleSelectWidget (index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetAdd (evt) {
    		let newIndex = evt.newIndex
	      let to = evt.to
	      //为拖拽到容器的元素添加唯一 key
	      const key = Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
	      this.$set(this.data.list, newIndex, {
	        ...this.data.list[newIndex],
	         options: this.data.list[newIndex].options ? JSON.parse(JSON.stringify(this.data.list[newIndex].options)) : null,
	         remoteFunc: 'func_' + key,
	        key,
	        // 绑定键值
	        model: this.data.list[newIndex].type + '_' + key,
	        rules: []
	      })
        this.selectWidget = this.data.list[newIndex]
        this.isAdd = true
    },
    handleWidgetColAdd ($event, row, colIndex) {
      console.log('coladd', $event, row, colIndex)
      const newIndex = $event.newIndex
      const oldIndex = $event.oldIndex
      const item = $event.item

			this.col.colIndexNum = colIndex;
			this.col.newIndexNum = newIndex;

      // 防止布局元素的嵌套拖拽
      if (item.className.indexOf('data-grid') >= 0) {

        // 如果是列表中拖拽的元素需要还原到原来位置
        item.tagName === 'DIV' && this.data.list.splice(oldIndex, 0, row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[newIndex])

        row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list.splice(newIndex, 1)

        return false
      }

      console.log('from', item)

      const key = Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
      this.$set(row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list, newIndex, {
        ...row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[newIndex],
        options: this.data.list[0].options ? 
        row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list.length>0 && row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[0].options
        ?JSON.parse(JSON.stringify(row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[0].options)) 
        : null 
        : null,
        remoteFunc: 'func_' + key,
        key,
        // 绑定键值
        model: row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[newIndex].type + '_' + key,
        rules: []
      })

      this.selectWidget = row.options.filter(x => x.attrName == 'grid')[0].group[colIndex].list[newIndex]
    },
    handleWidgetColAddtab ($event, row, colIndex) {
      const newIndex = $event.newIndex
      const oldIndex = $event.oldIndex
      const item = $event.item

			this.tab.colIndexNum = colIndex;
			this.tab.newIndexNum = newIndex;

      // 防止布局元素的嵌套拖拽
      if (item.className.indexOf('data-grid') >= 0) {

        // 如果是列表中拖拽的元素需要还原到原来位置
        item.tagName === 'DIV' && this.data.list.splice(oldIndex, 0, row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[newIndex])

        row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list.splice(newIndex, 1)

        return false
      }

      console.log('from', item)

      const key = Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)

      this.$set(row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list, newIndex, {
        ...row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[newIndex],
        options: this.data.list[0].options ? 
        row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list.length>0 && row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[0].options
        ?JSON.parse(JSON.stringify(row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[0].options)) 
        : null
        : null,
        remoteFunc: 'func_' + key,
        key,
        // 绑定键值
        model: row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[newIndex].type + '_' + key,
        rules: []
      })

      this.selectWidget = row.options.filter(x => x.attrName == 'tabChange')[0].group[colIndex].list[newIndex]
    },
    handleWidgetClone (index) {
      let cloneData = {
        ...this.data.list[index],
        options: [...this.data.list[index].options],
        key: Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
      }

      if (this.data.list[index].type === 'radio' || this.data.list[index].type === 'checkbox') {

        cloneData = {
          ...cloneData,
          options: {
            ...cloneData.options,
            options: cloneData.options.options.map(item => ({...item}))
          }
        }
      }

      this.data.list.splice(index, 0, cloneData)

      this.$nextTick(() => {
        this.selectWidget = this.data.list[index + 1]
      })
    },
    handleWidgetDelete (index) {
      if (this.data.list.length - 1 === index) {
        if (index === 0) {
          this.selectWidget = {}
        } else {
          this.selectWidget = this.data.list[index - 1]
        }
      } else {
        this.selectWidget = this.data.list[index + 1]
      }

      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
  },
  watch: {
    select (val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler (val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vueformmaking/WidgetForm.vue